export const percentage = (value, signed = false) => {
  const number = (Number(value) || 0) * 100;
  return `${signed && number > 0 ? "+" : ""}${number.toFixed(Math.abs(number) < 1 ? 1 : 0)}%`;
};

// For API fields already expressed in percentage points (e.g. alert
// thresholds, last_probability, notification probability).
export const percentagePoints = (value) => `${(Number(value) || 0).toFixed(0)}%`;

export const money = (cents, currency = "USD") =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency,
    maximumFractionDigits: 2,
  }).format((Number(cents) || 0) / 100);

export const orderEstimate = (quantity, price, feeBps = 10) => {
  const grossCents = Math.round(Number(quantity) * Number(price) * 100);
  const feeCents = Math.round((grossCents * feeBps) / 10000);
  return {
    grossCents,
    feeCents,
    totalCents: grossCents + feeCents,
    payoutCents: Math.round(Number(quantity) * 100),
  };
};
